import { contains, has, prop } from 'ramda';
import { contained } from 'ramda-adjunct';
import { MediaType } from '../../constants/MediaType';
import { TranscodingStatus } from '../../constants/TranscodingStatus';

export const getTranscodingStatus = prop('transcodingStatus');
export const hasTranscodingStatus = has('transcodingStatus');

export const isTranscoding = (item) =>
  hasTranscodingStatus(item) &&
  contains(getTranscodingStatus(item), [
    TranscodingStatus.InDownloadQueue,
    TranscodingStatus.Uploading,
    TranscodingStatus.InStorage,
    TranscodingStatus.Pending,
    TranscodingStatus.InQueue,
    TranscodingStatus.InProgress,
  ]);

export const isTranscodableMediaType = contained<MediaType>([
  MediaType.Video,
  MediaType.SecureVideo,
  MediaType.SecureMusic,
]);

export const isReady = (item) => {
  if (!hasTranscodingStatus(item)) {
    return true;
  }
  return getTranscodingStatus(item) === TranscodingStatus.Ready;
};

export const isFailed = (item) => {
  if (!hasTranscodingStatus(item)) {
    return false;
  }
  return getTranscodingStatus(item) === TranscodingStatus.Failed;
};

export const isStatusOkayToDisplayInItemsList = contained<TranscodingStatus>([
  TranscodingStatus.InQueue,
  TranscodingStatus.InProgress,
  TranscodingStatus.Ready,
  TranscodingStatus.Failed,
]);
